import httpBase from "../utils/http.utils";
import {
  GET_CREDIT_BALANCE,
  GET_CREDIT_HISTORY
} from "../constants/url";

export const getCreditHistoryApi = ({
  params,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      const response = await httpBase().get(GET_CREDIT_HISTORY, {
        params: params,
      });
      successCallback(response?.data);
    } catch (e) {
      failureCallback(e);
    } finally {
      finalCallback();
    }
  };
}

export const getCreditBalanceApi = ({
  params,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      const response = await httpBase().get(GET_CREDIT_BALANCE, {
        params: params,
      });
      successCallback(response?.data);
    } catch (e) {
      failureCallback(e);
    } finally {
      finalCallback();
    }
  };
}

export const createCheckoutSessionApi = ({
  data,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      const response = await httpBase().post("/payments/create-checkout-session", data);
      successCallback(response?.data);
    }
    catch (e) {
      failureCallback(e);
    }
    finally {
      finalCallback();
    }
  };
}

export const getCreditRateApi = ({
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      const response = await httpBase().post("/payments/credit-rate");
      successCallback(response?.data);
    }
    catch (e) {
      failureCallback(e);
    }
    finally {
      finalCallback();
    }
  };
}

export const getPaidStatusApi = ({
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      const response = await httpBase().post("/payments/paid-status");
      successCallback(response?.data);
    }
    catch (e) {
      failureCallback(e);
    }
    finally {
      finalCallback();
    }
  };
}

export const getCreditPurchaseHistoryApi = ({
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      const response = await httpBase().post("/payments/credit-purchase-history");
      successCallback(response?.data);
    }
    catch (e) {
      failureCallback(e);
    }
    finally {
      finalCallback();
    }
  };
}
